import React, { useEffect, useState, useContext, useRef, useCallback, useMemo } from "react";
import Web3 from "web3";
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { useWeb3React } from "@web3-react/core";

import ContractContext from '../ContractContext';
import DataContext from "../DataContext";

import { Button } from 'primereact/button';
import splashIcon from "../imgs/floatie_pink_icon.png";
import radarIcon from '../imgs/radar_blue_icon.png';
import refuelIcon from '../imgs/refuel_color_icon.png';
import disconnectIcon from '../imgs/FloatieDisconnect_icon.png';
import floatiePenguin1 from '../imgs/floatie_penguin_1.png'
import floatiePenguin2 from '../imgs/floatie_penguin_2.png'
import floatiePenguinFull1 from '../imgs/floatie_penguin_full_1.png'
import floatiePenguinFull2 from '../imgs/floatie_penguin_full_2.png'

import { getTokenPrice } from '../utils';
import Swap from './subcomponents_floatie/Swap';
import { Pay, Burn, Stake } from './subcomponents_floatie/PayBurn';

import LockerBay from "./subcomponents_floatie/LockerBay";
import FloatieDAO from "./subcomponents_floatie/FloatieDAO";
import FloatiePark from "./subcomponents_floatie/FloatiePark";
import ControlDeck from "./subcomponents_floatie/ControlDeck";

import BigNumber from 'bignumber.js'

export const Floatie = () => {
  const { library, account, active, } = useWeb3React();
  const { contracts } = useContext(ContractContext);
  const { data, setData } = useContext(DataContext);
  const [smartCodeData, setSmartCodeData] = useState({});
  const [dbError, setDbError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [bnbBalance, setBnbBalance] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndex2, setActiveIndex2] = useState(0);
  const toast = useRef(null);
  const [loading, setLoading] = useState(true);
  const [bnbPrice, setBnbPrice] = useState(0);

  const isWalletConnected = useCallback(() => account !== null, [account]);

  const rocketFiPrice = useMemo(() => getTokenPrice(data?.tokensList, "ROCKETFI"), [data?.tokensList]);
  const [walletVisible, setWalletVisible] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [manualRefresh, setManualRefresh] = useState(false);

  const createTokensList = useCallback((tokenPoolData, pricingData) => {

    return tokenPoolData.map((tokenData) => {
      if (!tokenData) return undefined;
      const tokenAddress = tokenData._tokenAddress.toLowerCase();
      const pricingToken = pricingData[tokenAddress];
      let tokenPrice = pricingToken ? pricingToken.usd : undefined;
      return {
        value: tokenData._tokenAddress,
        label: tokenData._symbol,
        rocketFiSubscribed: tokenData._shareCount / (10 ** 9),
        totalDistributed: tokenData._totalDistributed,
        decimals: tokenData._decimals,
        poolID: tokenData._poolID,
        unclaimedAmount: tokenData._unclaimedAmount,
        claimedAmount: tokenData._claimedAmount,
        routerAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        address: tokenData._tokenAddress,
        price: tokenPrice,
        reflectionPoolAddress: tokenData._reflectionPoolAddress,
        balanceOfHolder: tokenData._balanceOfHolder,
        totalSupply: tokenData._totalSupply,
        name: tokenData._name,
      };
    });
  }, []);

  useEffect(() => {
    if (isWalletConnected() && contracts) {
      getData();
      const timer = setInterval(getData, 120000);
      return () => clearInterval(timer);
    }
  }, [account, contracts]);

  useEffect(() => {
    if (data?.activePoolAddress && data?.tokenPoolDataRp && data?.pricingData)
      getAdditionalData();

  }, [data?.activePoolAddress, data?.tokenPoolDataRp, data?.pricingData]);

  useEffect(() => {
    if (dbError && toast) {
      toast.current.show({ severity: 'warn', summary: 'Warning Message', detail: errorMessage, life: 5000 }); // display the custom error message
    }
  }, [dbError, errorMessage]);

  useEffect(() => {
    if (data?.tokensListRp) {
      setLoading(false); // Hide the loading dialog once data is available
    }
  }, [data?.tokensListRp]);

  useEffect(() => {
    if (!library) return;
    const web3 = new Web3(library.provider);
    web3.eth.getBalance(account).then((balance) => {
      //console.log("balance:", balance);
      setBnbBalance(balance);
    });
  }, [library, account, data]);

  //db calls
  const getDatabaseData = useCallback(async (_url, _endPoint, _parms) => {
    const data = await fetch(_url + _endPoint + "?" + _parms, {
      method: "GET",
      headers: {
        //'Authorization': bearer,
        "x-floatie-api-key": "hrNqBjEIOaMLvY7SNXQtYOca5LvlQPn6O3oduqOwg3L3up20",
        "x-floatie-api-secret": "O3Ux1HsMC8Qcd0rb",
        "Content-Type": "application/json",
      },
    });

    var jsondata = await data.json();
    return jsondata.result;
  }, []);




  //web3 calls
  const getPrimaryData = useCallback(async () => {
    const [_contractData, _tokenPoolData] = await Promise.all([
      getContractData(contracts.rocketFiOracle, account),
      getTokenPoolData(contracts.rocketFiOracle, account),
    ]);


    //console.log("activePoolAddress:", str1);

    // Fetch data from rocketFiOracleV1 and rocketFiOracleV2 in the background
    const [
      contractDataRpRes, tokenPoolDataRpRes] = await Promise.allSettled([
        getContractData(contracts.rp_rocketFiOracle, account),
        getTokenPoolData(contracts.rp_rocketFiOracle, account),
      ]);

    const contractDataRp = contractDataRpRes.status === 'fulfilled' ? contractDataRpRes.value : [];
    const tokenPoolDataRp = tokenPoolDataRpRes.status === 'fulfilled' ? tokenPoolDataRpRes.value : [];


    const activePoolAddress = [
      ...new Set(
        tokenPoolDataRp.map((obj) => obj._tokenAddress)
      ),
    ];

    const str1 = activePoolAddress.toString();

    return {
      activePoolAddress: str1,
      contractDataRp,
      tokenPoolDataRp,
    };
  }, [contracts, account]);


  const getSecondaryData = useCallback(async (activePoolAddress, _tokenPoolDataRp, pricingData) => {
    const [_dbData] = await Promise.all([
      getDatabaseData("https://api.rocketfi.app/v1/", "tokens", "addresses=" + activePoolAddress + "&limit=" + activePoolAddress.length),
    ]);

    if (!_dbData || _dbData.length === 0) {
      setErrorMessage("Database did not return any data"); // set custom error message when _dbData doesn't return anything
      setDbError(true);
    } else {
      const _tokensListRp = createTokensList(_tokenPoolDataRp, pricingData);
      return {
        dbData: _dbData,
        tokensListRp: _tokensListRp,
      };
    }
  }, [contracts, data]);

  const getPricingData = useCallback(async () => {
    // Here, fetch the pricing data for all tokens you are interested in
    const allSmartRewardsBnbValue = await getAllSmartRewardsBnbValues(contracts.liquidityOracle);
    const allSmartRewardsUsdValue = await getAllSmartRewardsUsdValues(contracts.liquidityOracle);

    let pricingData = {};

    for (let i = 0; i < allSmartRewardsBnbValue[0].length; i++) {
      let address = allSmartRewardsBnbValue[0][i];
      pricingData[address.toLowerCase()] = {
        usd: allSmartRewardsUsdValue[1][i] / 10 ** 18,
        bnb: allSmartRewardsBnbValue[1][i] / 10 ** 18,
      }
    }

    // Manually add pricing for fixed addresses
    pricingData["0x2e3B6906B976AB8Da82228e0569B3ef6ea1e8Cc6".toLowerCase()] = { usd: 1.0 };
    pricingData["0x27874A586bafaF54d4Cd0aae368ad9569D06d115".toLowerCase()] = { usd: 1.0 };

    // Replace pricing for specified tokens with alternate address pricing
    const replacements = {
      "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
      "0x904B4224acA463666E98f21cC8C54f8D423f6648": "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
      "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA": "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
      "0x3834303483f139c26bc282528aDee6b7Da103D54": "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
      "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8": "0x570a5d26f7765ecb712c0924e4de545b89fd43df",
      "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132": "0x2859e4544C4bB03966803b044A93563Bd2D0DD4D",
      "0x2761c609f3DbA79FFb34d28ab8d9cc2FF381fD3A": "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
      "0xb014728C841D8Ccca6C236fE04B274D206cc60D0": "0xba2ae424d960c26247dd6c32edc70b295c744c43",
      "0x58291c58A2c4AEc7Ad24BaA87988dFc39f3FBC25": "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
    };

    Object.entries(replacements).forEach(([original, alternate]) => {
      const originalLower = original.toLowerCase();
      const alternateLower = alternate.toLowerCase();
      // Check if both original and alternate addresses exist in pricingData
      if (pricingData[originalLower] && pricingData[alternateLower]) {
        // Replace original token's pricing with alternate token's pricing
        pricingData[originalLower] = { ...pricingData[alternateLower] };
      }
    });

    return { pricingData };
  }, [contracts]);


  const getData = useCallback(async () => {
    setIsRefreshing(true);
    setLoading(true);
    if (!isWalletConnected() || !contracts || !contracts.rp_rocketFiOracle) {
      //console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }

    try {
      // get pricing data
      const pricingData = await getPricingData();
      const primaryData = await getPrimaryData();

      const newData = {
        ...data,
        ...primaryData,
        ...pricingData,
      };

      setData(newData); // set the data state only once with the updated data
    } catch (err) {
      console.error("An error occurred while fetching contract data:", err);
    }
    setLoading(false);
  }, [contracts, account]);

  const getAdditionalData = useCallback(async () => {
    if (!isWalletConnected() || !contracts || !contracts.rp_rocketFiOracle) {
      //console.error("Please connect to a wallet before interacting with the contract.");
      return;
    }

    try {
      const secondaryData = await getSecondaryData(data.activePoolAddress, data.tokenPoolDataRp, data.pricingData);
      //console.log("secondaryData:", secondaryData);
      const newData = {
        ...data,
        ...secondaryData,
      };

      setData(newData); // set the data state only once with the updated data
    } catch (err) {
      console.error("An error occurred while fetching contract data:", err);
    }
    if (manualRefresh) {
      //GetPastBurnEvents();
      setManualRefresh(false);

      setTimeout(() => {
        toast.current.show({ severity: 'success', summary: 'Data Refreshed', detail: new Date().toLocaleString(), life: 2500 });
        setIsRefreshing(false);
      }, 250);
    }
    else {
      setIsRefreshing(false);
    }

  }, [contracts, account, data]);

  const getContractData = useCallback(async (contract, account) => {
    return await contract.methods.getRocketData(account).call();
  }, []);

  const getTokenPoolData = useCallback(async (contract, account) => {
    return await contract.methods.getTokenPoolData(account).call();
  }, []);

  const getTokenBnbValueSmartRewards = useCallback(async (contract, token) => {
    return await contract.methods.getTokenBnbValueSmartRewards(token.address, true, true).call();
  }, []);

  const getAllSmartRewardsBnbValues = useCallback(async (contract) => {
    return await contract.methods.getAllSmartRewardsBnbValues().call();
  }, []);

  const getAllSmartRewardsUsdValues = useCallback(async (contract) => {
    return await contract.methods.getAllSmartRewardsUsdValues().call();
  }, []);

  const getSmartCodeData = useCallback(async () => {
    const result = await contracts.smartCodes.methods.smartCodeData(account).call();
    //console.log("getSmartCodeData:", result);
    return result;
  }, [contracts, account]);


  useEffect(() => {
    const fetchSmartCodeData = async () => {
      const result = await getSmartCodeData();
      setSmartCodeData(result);
    };

    if (data && contracts.smartCodes) {
      fetchSmartCodeData();
    }
  }, [data, contracts]);

  //returns the price for 1 BNB in USD
  const getBNBPrice = useCallback(async (contract) => {
    let value = new BigNumber('1000000000000000000');
    return await contract.methods.getBNBValueToken("0xe9e7cea3dedca5984780bafc599bd69add087d56", value.toString(), "0x10ED43C718714eb63d5aA57B78B54704E256024E").call();
  }, []);

  const fetchBNBPrice = useCallback(async () => {
    const bnbData = await getBNBPrice(contracts.liquidityOracle);

    const bnbPrice = bnbData / (10 ** 18);

    return bnbPrice;
  }, [contracts.liquidityOracle]);



  const setBNBPrice = async () => {
    const bnbPrice = await fetchBNBPrice();
    setBnbPrice(bnbPrice);
  }

  useEffect(() => {
    setBNBPrice();
  }, [contracts.liquidityOracle, account]);

  useEffect(() => {
    if (bnbPrice > 0) {
      console.log("BNB Price:", bnbPrice);
    }
  }, [bnbPrice]);

  const headerFormat = (header) => {
    return (
      <div style={{ color: '#EC599A' }}>
        {header}
      </div>
    );
  }

  const [visible, setVisible] = useState(false);

  const dialogFooter = <div className="p-d-flex p-jc-center">Loading your fun-filled experience...</div>;


  return (
    (active) && (account.toLowerCase() == "0x5B51a16de51a7CEd3a01735Ba03FaaC7171275f9".toLowerCase() || account.toLowerCase() == "0x7a4084446417AB470D5e542c0f722Cf91cbE77a7".toLowerCase() || account.toLowerCase() == "0x08Ccd6843BFD6C5634a643D0d3BA2E37768a35Df".toLowerCase() ||
      account.toLowerCase() == "0xBdf3c6073Af427b42c0DFa4bf29107a2Cbd0923a".toLowerCase() || account.toLowerCase() == "0x3a5EE5cCD74Dd63d8129E0BC7AC207afdbc592AE".toLowerCase() || account.toLowerCase() == "0x4b26Aa2D910A8FFB62CA5D17ac227323dC3Bd6E1".toLowerCase()
      || account.toLowerCase() == "0x9f4C7da001F4a52C69f7c43E582734972Ee979E1".toLowerCase() || account.toLowerCase() == "0x471b97c7de405Ab4cEBD0bF62CdB358fefa4Def8".toLowerCase() || account.toLowerCase() == "0x8c8A42Dd192881550B7bc77d81AC6EcA11D041F2".toLowerCase()
      || account.toLowerCase() == "0x08ccd6843bfd6c5634a643d0d3ba2e37768a35df".toLowerCase() || account.toLowerCase() == "0x71De1Af1e55b6A70E273A853CF8DF52fE510010C".toLowerCase()
      
      || account.toLowerCase() == "0x8C2bf188a20dC33eAa10B89046d1f559300c40bd".toLowerCase() //Atron
    
    )

      ?

      <div style={{ marginBottom: '50px' }}>
        <Toast ref={toast} />
        {/* {data && <Button icon={isRefreshing ? "pi pi-spin pi-refresh" : "pi pi-refresh"}
          onClick={() => {
            setManualRefresh(true);
            getData();
          }} rounded severity="secondary" aria-label="Refresh Data"
          disabled={isRefreshing}
          style={{
            position: 'fixed', right: '22px', bottom: '80px',
            padding: '25px',
            //backgroundColor: '#f8f9fa',
            backgroundColor: '#4f4f4f',
            zIndex: '9999',
          }}
          size="large"
        ></Button>} */}

        <Dialog header="Loading"
          //visible={loading} 
          visible={false}
          footer={dialogFooter} onHide={() => { }} closable={false}
          style={{ width: '50vw' }}>
          {/* <div style={{ textAlign: 'center' }}>
            <img src={floatiePenguinLoading} alt="Loading" style={{ width: '100px', marginBottom: '20px' }} />
            <div>Hold tight! Your Floatie experience is getting ready...</div>
          </div> */}
        </Dialog>
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          {/* <TabPanel header="FloatiePark" >
            <div >
              <FloatiePark tokenSelections={data?.tokensListRp} refreshTokenSelections={getData} imageReferences={data?.dbData} />
            </div>
          </TabPanel> */}
          <TabPanel header="Swap" >
            <div style={{
              marginLeft: '-20px',
              marginRight: '-20px',
            }}>
              <Swap tokenSelections={data?.tokensListRp} refreshTokenSelections={getData} imageReferences={data?.dbData} />
            </div>
          </TabPanel>
          <TabPanel header="StakeHause">
            <div style={{
              marginLeft: '-20px',
              marginRight: '-20px',
            }}>
              <Stake tokenSelections={data?.tokensListRp} refreshTokenSelections={getData} imageReferences={data?.dbData} />
            </div>
          </TabPanel>
          <TabPanel header="BurnLab">
            <div style={{
              marginLeft: '-20px',
              marginRight: '-20px',
            }}>
              <Burn tokenSelections={data?.tokensListRp} refreshTokenSelections={getData} imageReferences={data?.dbData} />
            </div>
          </TabPanel>
          <TabPanel header="EarnPay">
            <div style={{
              //marginLeft: '-20px',
              //marginRight: '-20px',
            }}>
              <Pay tokenSelections={data?.tokensListRp} refreshTokenSelections={getData} imageReferences={data?.dbData} />
            </div>
          </TabPanel>
          <TabPanel disabled header="Liquidity">

          </TabPanel>
          <TabPanel header="Lockers">
            <div style={{
              marginLeft: '-20px',
              marginRight: '-20px',
            }}>
              <LockerBay tokenSelections={data?.tokensListRp} refreshData={getData} imageReferences={data?.dbData} />
            </div>
          </TabPanel>

          <TabPanel disabled header="SwapFactory">

          </TabPanel>
          <TabPanel header="ControlDeck">
            <div style={{
              marginLeft: '-20px',
              marginRight: '-20px',
            }}>
              <ControlDeck tokenSelections={data?.tokensListRp} refreshData={getData} imageReferences={data?.dbData} />
            </div>
          </TabPanel>
          <TabPanel header="DAO">
            <div style={{
              marginLeft: '-20px',
              marginRight: '-20px',
            }}>
              <FloatieDAO tokenSelections={data?.tokensListRp} refreshData={getData} imageReferences={data?.dbData} />
            </div>
          </TabPanel>
        </TabView>
      </div>
      :
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '10px', marginTop: '20px', marginLeft: '20px', marginRight: '20px' }}>
        <RenderSplashScreen />
      </div>
  );
};

export default React.memo(Floatie);


const RenderSplashScreen = () => {
  const styles = {
    splashContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start', // Changed to flex-start to align items to the top
      alignItems: 'center',
      background: 'white',
      borderRadius: '24px',
      paddingBottom: '20px',
      boxSizing: 'border-box',
      position: 'relative', // Added to position elements absolutely inside
    },
    header: {
      color: 'black',
      fontSize: '1.8em',
      //fontFamily: 'Inter',
      fontWeight: '700',
      textAlign: 'center',
      wordWrap: 'break-word',
      marginBottom: '40px', // Increased margin
      maxWidth: '80%', // Ensure the header text doesn't span the full width
    },
    stepContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start', // Changed to flex-start to align items to the left
      width: '100%',
      gap: '20px', // Increased gap for better spacing
      //marginBottom: '40px', // Increased margin
    },
    stepTitle: {
      color: 'rgba(247, 247, 247, 0.4)',
      fontSize: '2.2em',
      //fontFamily: 'Inter',
      fontWeight: '700',
      alignSelf: 'flex-start', // Align to the start of the flex container
    },
    stepContent: {
      display: 'flex',
      alignItems: 'center', // Adjusted for vertical alignment
      flexDirection: 'row',
      gap: '10px',
    },
    stepIcon: {
      width: '45px',
      height: '45px',
      position: 'absolute',
      top: '0', // Align icons to the top of the overlayIcons div
    },
    stepText: {
      color: '#F8F8F8',
      fontSize: '1.1em',
      //fontFamily: 'Inter',
      fontWeight: '400',
      textAlign: 'left', // Align text to the left
    },
    overlayIcons: {
      display: 'flex',
      position: 'relative',
      // You might want to adjust the width to prevent the icons from overlapping the text
      width: '120px', // Width should be the total width of the three icons considering their overlap
      height: '45px', // Set the height to that of the icons to prevent overlap with other elements
      justifyContent: 'flex-start', // Aligns the icons to the start
    },
    step1Icon: {
      width: '45px',
      height: '45px',
      position: 'relative', // or 'static' if you don't need any special positioning
      // Other styles specific to step 1 icon
    },
    step2Icon: {
      width: '45px',
      height: '45px',
      position: 'absolute',
      top: '0', // Align icons to the top of the overlayIcons div
    },
    list: {
      listStyle: 'none',
      paddingLeft: '0px', // Set padding to 0 for custom indentation
    },
    listItem: {
      position: 'relative', // Positioned relatively to use absolute for pseudo-elements
      //paddingLeft: '1em', // Space for the bullet
      marginBottom: '0.5em', // Space between list items
      '&::before': {
        content: '"•"', // Unicode character for bullet
        color: '#FBAF00', // Custom color for the bullet, match your design
        position: 'absolute', // Positioned absolutely to place it on the left of the item
        left: '0', // Align to the left
      },
      color: '#F8F8F8',
      fontSize: '1.1em',
      //fontFamily: 'Inter',
      fontWeight: '400',
    },
    listItemBold: {
      position: 'relative', // Positioned relatively to use absolute for pseudo-elements
      paddingLeft: '1em', // Space for the bullet
      marginBottom: '0.5em', // Space between list items
      '&::before': {
        content: '"•"', // Unicode character for bullet
        color: '#FBAF00', // Custom color for the bullet, match your design
        position: 'absolute', // Positioned absolutely to place it on the left of the item
        left: '0', // Align to the left
      },
      color: '#F8F8F8',
      fontSize: '1.1em',
      //fontFamily: 'Inter',
      fontWeight: '800',
    },
    dashboardAccess: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start', // This aligns items to the left
      flexWrap: 'nowrap', // Prevents the items from wrapping onto the next line
      gap: '10px', // This adds some space between the icons and the text
    },
    radarIcon: {
      left: '0',
      zIndex: '3',
    },
    refuelIcon: {
      left: '20px',
      zIndex: '2',
    },
    splashIcon: {
      left: '40px',
      zIndex: '1',
    },
  };


  // Array of images
  const floatiePenguinImages = [floatiePenguinFull1, floatiePenguinFull2];

  // Function to get a random image
  const getRandomFloatiePenguin = () => {
    const randomIndex = Math.floor(Math.random() * floatiePenguinImages.length);
    return floatiePenguinImages[randomIndex];
  };

  // Use the function to get a random image for rendering
  const randomPenguinImage = getRandomFloatiePenguin();

  return (
    <div style={styles.splashContainer}>
      {/* <img src={splashIcon} alt="RocketFi" style={{ width: '90px', marginBottom: '20px' }} />
      <div style={styles.header}>Coming Soon</div> */}
      <img src={randomPenguinImage} alt="RocketFi" style={{ width: '100%', maxWidth: '500px', position: 'relative' }} />
      {/* floatie penguin must be on the bottom left*/}
      {/* <img src={floatiePenguin1} alt="RocketFi" style={{ width: '400px', position: 'absolute', bottom: '0', left: '0' }} /> */}
      {/* floatie penguin must be on the bottom right*/}
      {/* <img src={floatiePenguin2} alt="RocketFi" style={{ width: '75%', position: 'relative' }} />
    <div style={styles.header}>coming soon</div> */}
    </div>
  );
};





// <div>
// <div style={styles.stepContainer}>
//   <div style={styles.stepTitle}>STEP 1</div>
//   <div style={styles.stepContent}>
//     <div style={styles.step1Icon}>
//       <div style={{ ...styles.step1Icon, backgroundColor: '#FFE37B', borderRadius: '50%' }} />
//       <img src={disconnectIcon} alt="Connect Wallet" style={{ width: '25px', height: '25px', position: 'absolute', left: '10px', top: '10px' }} />
//     </div>
//     <div style={styles.stepText}>Press “Tap To Connect” button on top right.</div>
//   </div>
// </div>

// <div style={{ ...styles.stepContainer, marginTop: '40px' }}>
//   <div style={styles.stepTitle}>STEP 2</div>
//   <div style={styles.dashboardAccess}> {/* This div wraps the icons and the text */}
//     <div style={styles.overlayIcons}>
//       <img src={radarIcon} alt="Radar" style={{ ...styles.step2Icon, ...styles.radarIcon }} />
//       <img src={refuelIcon} alt="Refuel" style={{ ...styles.step2Icon, ...styles.refuelIcon }} />
//       <img src={splashIcon} alt="RocketFi" style={{ ...styles.step2Icon, ...styles.splashIcon }} />
//     </div>
//     <div style={styles.stepText}>Get Access To Dashboard + Tools</div>
//   </div>
//   <ul style={styles.list}>
//     <li><span style={styles.listItemBold}>• Customize</span><span style={styles.listItem}> Rewards</span></li>
//     <li><span style={styles.listItemBold}>• Create</span><span style={styles.listItem}> Smart Codes</span></li>
//     <li><span style={styles.listItemBold}>• Reward</span><span style={styles.listItem}> Insights</span></li>
//     <li><span style={styles.listItemBold}>• Gamified</span><span style={styles.listItem}> Reward Pools</span></li>
//   </ul>
// </div>

// </div>


